import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { vacantRentalObjectCommand } from '../../model/const/command';
import { AdvertiseRentalObjectCommandHandler } from './advertise-rental-object-command-handler.service';
import { CreateBlockContractRentalObjectCommandHandler } from './create-blockcontract-rental-object-command-handler.service';
import { CreateContractCommandHandler } from './create-contract-command-handler.service';
import { VacantParkingExportCommandHandler } from './vacant-parking-export-command-handler.service';

@Injectable()
export class VacantParkingCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    createContractHandler: CreateContractCommandHandler,
    createBlockContractHandler: CreateBlockContractRentalObjectCommandHandler,
    exportToExcelHandler: VacantParkingExportCommandHandler,
    advertiseHandler: AdvertiseRentalObjectCommandHandler
  ) {
    super();
    this.addHandler(vacantRentalObjectCommand.createContract, createContractHandler);
    this.addHandler(vacantRentalObjectCommand.createBlockContract, createBlockContractHandler);
    this.addHandler(vacantRentalObjectCommand.exportToExcel, exportToExcelHandler);
    this.addHandler(rentalObjectCommand.advertise, advertiseHandler);
  }
}
